import React from "react";

const LoaderInstructions = () => {
    return (
        <div className="item_loader_body_sidebar_instructions">
            <div className="loading_links fade-in"></div>
            <div className="loading_links fade-in"></div>
            <div className="item_loader_body_sidebar_card_instruction fade-in" />
        </div>
    );
};

export default LoaderInstructions;